import PubSub from '../classes/PubSub';

const eventBus = new PubSub();
export default eventBus;
